import { render } from "./MainFooter.vue?vue&type=template&id=5beeb184&scoped=true"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=5beeb184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5beeb184"]])

export default __exports__